import VideoShort from '@/components/VideoShort'
import { rbp } from '@/constants/measured-scope'
import { useFeatureToggle } from '@/context/featureToggles'
import { MicroLearningShortsSection } from '@/shared/api-generated-types'
import CardRow from '@/widgets/CardRow'
import VideoCarousel from '@/widgets/VideoCarousel'
import { useMediaQuery } from '@react-hookz/web'
import React from 'react'

export interface Props extends MicroLearningShortsSection {
  className?: string
}

const MicroShortBlock = ({ items, title }: Props): JSX.Element | null => {
  const canSeeExpMicroShorts = useFeatureToggle('exp_micro_learning')
  const isSmallDevice = useMediaQuery(`only screen and (max-width : ${rbp.tablet})`, { initializeWithValue: false })

  if (!canSeeExpMicroShorts) return null
  if (!items || items?.length === 0) return null

  const videoItems = items
    ? items.map((item, k) => {
        return <VideoShort key={k} {...item} />
      })
    : []

  return (
    <>
      {isSmallDevice ? (
        <VideoCarousel carousel="always" title={title}>
          {videoItems}
        </VideoCarousel>
      ) : (
        <CardRow carousel="always" title={title}>
          {videoItems}
        </CardRow>
      )}
    </>
  )
}
export default React.memo(MicroShortBlock)
